import React from 'react'
import { Col, Row } from 'antd'
import './style.less'
import { AIQualityCheckPlanDetailItem } from 'src/types/ai-quality-check'
import { translateToFormValues } from '../utils'

const PreviewMoc = ({ qcPlanDetail }: { qcPlanDetail: AIQualityCheckPlanDetailItem | null }) => {
  const translatedData = translateToFormValues(qcPlanDetail)
  return (
    <div className="scheme-preview-moc-container">

      {translatedData?.nodeResults?.map((item, index) => (
        <div key={index}>
          <Row className="node-container">
            <Col span={2}>
              <h4 className="node-label">
                板块:
              </h4>
            </Col>
            <Col span={21}>
              <span className="node-value">{item.moduleName}</span>
            </Col>
          </Row>
          {item?.items?.map((subItem, subIndex) => (
            <Row key={subIndex} className="rule-container">
              <Col span={2}>
                <h4 className="node-label" style={{ marginTop: 6 }}>
                  评分项{subIndex + 1}:
                </h4>
              </Col>
              <Col span={21}>
                <div className="rule-content">
                  <h4>
                    {subItem?.name}（{subItem?.scoreRangeMax}分）
                  </h4>
                  <div className="rule-content-description">
                    <span className="description-label">具体描述:</span>
                    <p>
                      {subItem?.description}
                    </p>
                  </div>
                  <div className="rule-content-description">
                    <span className="description-label">评分细则:</span>
                    <ul className="rule-list">
                      {subItem?.subItems?.map((subSubItem, subSubIndex) => (
                        <li key={subSubIndex}>
                          <p>
                            {subSubItem?.scoreRangeMin === subSubItem?.scoreRangeMax ? `${subSubItem?.scoreRangeMin}分:${subSubItem?.description}` : `${subSubItem?.scoreRangeMin}-${subSubItem?.scoreRangeMax}分:${subSubItem?.description}`}
                          </p>
                        </li>
                      ))}
                    </ul>
                  </div>

                </div>
              </Col>
            </Row>
          ))}
        </div>
      ))}
    </div>
  )
}

export default PreviewMoc
